<script>
    import Layout from "../../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Forms from "../../../../mixins/Forms";
    import Tickets from "../../../../mixins/Tickets";
    import {Editor, EditorContent, EditorMenuBar} from 'tiptap';
    import {
        Blockquote,
        CodeBlock,
        HardBreak,
        Heading,
        OrderedList,
        BulletList,
        ListItem,
        TodoItem,
        TodoList,
        Bold,
        Code,
        Italic,
        Link,
        Strike,
        Underline,
        History,
    } from 'tiptap-extensions';
    import axios from 'axios';

    /**
     * Ticket template create component
     */
    export default {
        page: {
            title: "Edit Ticket Template",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader, EditorMenuBar, EditorContent},
        mixins: [Forms, Tickets],
        mounted() {
            this.setupEditor();
        },
        created() {
            this.loadTicketTemplate(this.$route.params.id);
        },
        data() {
            return {
                title: "Edit Ticket Template",
                items: [
                    {
                        text: "Settings",
                        href: "#"
                    },
                    {
                        text: "Edit Ticket Template",
                        active: true
                    }
                ],
                ticketTemplate: [],
                serverErrors: [],
                isLoading: false,
                isSaving: false,
                editor: null
            };
        },
        methods: {
            loadTicketTemplate(id) {
                let vm = this;
                vm.ticketTemplate = null;
                vm.isLoading = true;
                axios.get(API_BASE + '/ticket-templates/' + id).then(r => {
                    vm.isLoading = false;
                    vm.ticketTemplate = r.data;
                    vm.editor.setContent(vm.ticketTemplate.description);
                }).catch(e => {
                    console.log(e);
                    vm.isLoading = false;
                    vm.setErrors(e);
                });
            },

            attemptSave() {
                this.save();
            },

            save() {
                let vm = this;

                vm.isSaving = true;
                axios.put(API_BASE + '/ticket-templates/' + this.ticketTemplate.id, {
                    ...vm.ticketTemplate,
                    description: vm.editor.getHTML()
                }).then(r => {
                    vm.isSaving = false;
                    this.$notify.success({
                        title: 'Success!',
                        message: 'Template updated successfully'
                    });
                    vm.$router.push('/settings/ticket-templates/');
                }).catch(e => {
                    console.log(e);
                    vm.isSaving = false;
                    vm.setErrors(e);
                });
            },

            setupEditor() {
                let vm = this;
                this.editor = new Editor({
                    extensions: [
                        new Blockquote(),
                        new CodeBlock(),
                        new HardBreak(),
                        new Heading({levels: [1, 2, 3]}),
                        new BulletList(),
                        new OrderedList(),
                        new ListItem(),
                        new TodoItem(),
                        new TodoList(),
                        new Bold(),
                        new Code(),
                        new Italic(),
                        new Link(),
                        new Strike(),
                        new Underline(),
                        new History(),
                    ]
                })
            }
        }
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items"/>
        <errors :error-list="serverErrors"></errors>
        <loading-screen :is-loading="isLoading||isSaving"></loading-screen>
        <div class="row" v-if="ticketTemplate">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <!--            <h4 class="card-title mb-4">Ticket Details</h4>-->
                        <form @submit.prevent="attemptSave">
                            <!-- Name -->
                            <div class="form-group row mb-4">
                                <label for="name" class="col-form-label col-lg-2">Name</label>
                                <div class="col-lg-10">
                                    <input
                                            id="name"
                                            name="name"
                                            type="text"
                                            class="form-control"
                                            v-model="ticketTemplate.name"
                                            autofocus
                                    />
                                </div>
                            </div>
                            <!-- / Name -->

                            <!-- Subject -->
                            <div class="form-group row mb-4">
                                <label for="subject" class="col-form-label col-lg-2">Subject</label>
                                <div class="col-lg-10">
                                    <input
                                            id="subject"
                                            name="subject"
                                            type="text"
                                            class="form-control"
                                            v-model="ticketTemplate.subject"
                                    />
                                </div>
                            </div>
                            <!-- / Subject -->

                            <!-- Description -->
                            <div class="form-group row">
                                <label for="description" class="col-form-label col-lg-2">Description</label>
                                <div class="col-lg-10">
                                    <div class="card shadow-none card-action">
                                        <div class="card-body p-3">
                                            <editor-content :editor="editor"/>
                                        </div>
                                        <div class="card-menubar">
                                            <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
                                                <div class="menubar">

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       :class="{ 'is-active': isActive.bold() }"
                                                       @click="commands.bold"
                                                    >
                                                        <i class="fas fa-bold"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       :class="{ 'is-active': isActive.italic() }"
                                                       @click="commands.italic"
                                                    >
                                                        <i class="fas fa-italic"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       :class="{ 'is-active': isActive.strike() }"
                                                       @click="commands.strike"
                                                    >
                                                        <i class="fas fa-strikethrough"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       :class="{ 'is-active': isActive.underline() }"
                                                       @click="commands.underline"
                                                    >
                                                        <i class="fas fa-underline"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       :class="{ 'is-active': isActive.bullet_list() }"
                                                       @click="commands.bullet_list"
                                                    >
                                                        <i class="fas fa-list-ul"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       :class="{ 'is-active': isActive.ordered_list() }"
                                                       @click="commands.ordered_list"
                                                    >
                                                        <i class="fas fa-list-ol"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       @click="commands.undo"
                                                    >
                                                        <i class="fas fa-undo"></i>
                                                    </a>

                                                    <a href="#" class="btn btn-itg-white btn-sm menubar__button"
                                                       @click="commands.redo"
                                                    >
                                                        <i class="fas fa-redo"></i>
                                                    </a>
                                                </div>
                                            </editor-menu-bar>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <!-- / Description -->

                            <!-- Difficulty -->
                            <div class="form-group row mb-4">
                                <label for="description" class="col-form-label col-lg-2">Difficulty</label>

                                <div class="col-lg-10">
                                    <v-select :options="ticketDifficultyDropdownOptions" :reduce="difficulty => difficulty.value"
                                              v-model="ticketTemplate.difficulty"></v-select>
                                </div>
                            </div>
                            <!-- / Difficulty -->

                            <!-- Priority -->
                            <div class="form-group row mb-4">
                                <label for="priority" class="col-form-label col-lg-2">Priority</label>

                                <div class="col-lg-10">
                                    <v-select v-model="ticketTemplate.priority" :reduce="priority => priority.value"
                                              :options="ticketPriorityDropdownOptions"></v-select>
                                </div>
                            </div>
                            <!-- / Priority -->
                        </form>
                        <div class="row justify-content-end">
                            <div class="col-lg-10">
                                <button type="submit" class="btn btn-itg-dark" @click.prevent="attemptSave">Update
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>

<style scoped>
</style>
